/**
 * Calima - Cart Drawer (Sidebar) Manager
 */

(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    function defaultOption(opt, def) {
      return (typeof opt === 'undefined') ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)?.[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  var CartDrawer = {
    overlay: null,
    drawer: null,
    closeBtn: null,
    bodyContainer: null,
    countBadges: [],

    init: function () {
      this.overlay = document.getElementById('cart-drawer-overlay');
      this.drawer = document.getElementById('cart-drawer');
      this.closeBtn = document.getElementById('cart-drawer-close');
      this.bodyContainer = document.getElementById('cart-drawer-body');
      this.countBadges = document.querySelectorAll('#cart-count, #cart-drawer-count, .js-cart-count');

      this.bindEvents();
    },

    bindEvents: function () {
      var self = this;

      // Global click handler for open triggers
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-cart-drawer-toggle], .js-cart-drawer-open, .mainmenu__order-link, #cart-count');
        if (trigger) {
          e.preventDefault();
          self.open();
        }
      });

      // Close handlers
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function () {
          self.close();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', function () {
          self.close();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen()) {
          self.close();
        }
      });

      // Quantity & Remove handlers inside bodyContainer
      if (this.bodyContainer) {
        this.bodyContainer.addEventListener('click', function (e) {
          var decBtn = e.target.closest('.cart-drawer-item__qty-dec');
          var incBtn = e.target.closest('.cart-drawer-item__qty-inc');
          var removeBtn = e.target.closest('.cart-drawer-item__remove');

          if (decBtn) {
            e.preventDefault();
            var key = decBtn.dataset.key;
            var currentQty = parseInt(decBtn.dataset.qty, 10);
            self.updateQuantity(key, currentQty);
          } else if (incBtn) {
            e.preventDefault();
            var key = incBtn.dataset.key;
            var currentQty = parseInt(incBtn.dataset.qty, 10);
            self.updateQuantity(key, currentQty);
          } else if (removeBtn) {
            e.preventDefault();
            var key = removeBtn.dataset.key;
            self.updateQuantity(key, 0);
          }
        });

        this.bodyContainer.addEventListener('change', function (e) {
          var input = e.target.closest('.cart-drawer-item__qty-input');
          if (input) {
            var key = input.dataset.key;
            var newQty = parseInt(input.value, 10);
            if (!isNaN(newQty) && newQty >= 0) {
              self.updateQuantity(key, newQty);
            }
          }
        });
      }
    },

    isOpen: function () {
      return this.drawer && this.drawer.classList.contains('is-open');
    },

    open: function () {
      if (!this.drawer || !this.overlay) return;
      this.refresh();
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      if (!this.drawer || !this.overlay) return;
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    updateBadges: function (count) {
      var badges = document.querySelectorAll('#cart-count, #cart-drawer-count, .js-cart-count');
      badges.forEach(function (badge) {
        badge.textContent = count;
      });
    },

    refresh: function () {
      var self = this;
      fetch(window.location.origin + window.Shopify.routes.root + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.renderCart(cart);
          self.updateBadges(cart.item_count);
        })
        .catch(function (err) {
          console.error('Error fetching cart:', err);
        });
    },

    updateQuantity: function (key, quantity) {
      var self = this;
      fetch(window.location.origin + window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.renderCart(cart);
          self.updateBadges(cart.item_count);
        })
        .catch(function (err) {
          console.error('Error updating cart quantity:', err);
        });
    },

    renderCart: function (cart) {
      if (!this.bodyContainer) return;

      var transEl = document.getElementById('cart-drawer-translations');
      var t = {
        empty: 'Tu carrito está vacío.',
        go_to_shop: 'Seguir comprando',
        remove: 'Eliminar',
        quantity: 'Cantidad',
        subtotal: 'Subtotal',
        taxes_shipping: 'Envío e impuestos calculados al finalizar la compra',
        checkout: 'Finalizar compra',
        view_cart: 'VER CARRITO COMPLETO',
        complete_look: 'COMPLETA TU LOOK',
        add: 'AGREGAR'
      };
      if (transEl) {
        try {
          var parsedT = JSON.parse(transEl.textContent);
          if (parsedT) Object.assign(t, parsedT);
        } catch (e) {}
      }

      if (!cart || cart.item_count === 0) {
        this.bodyContainer.innerHTML = `
          <div class="cart-drawer__empty">
            <p class="cart-drawer__empty-text">${t.empty}</p>
            <a href="${window.Shopify?.routes?.root || '/'}collections" class="cart-drawer__empty-btn">${t.go_to_shop}</a>
          </div>
        `;
        return;
      }

      var itemsHtml = cart.items.map(function (item) {
        var imageSrc = item.image ? item.image : '';
        var imageHtml = imageSrc 
          ? `<img class="cart-drawer-item__image" src="${imageSrc}" alt="${item.product_title}" loading="lazy">`
          : `<div class="cart-drawer-item__image" style="background:#ddd"></div>`;

        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cart-drawer-item__variant">${item.variant_title}</p>`
          : '';

        var priceFormatted = formatMoney(item.final_line_price);

        return `
          <article class="cart-drawer-item" data-key="${item.key}">
            <a class="cart-drawer-item__image-wrap" href="${item.url}">
              ${imageHtml}
            </a>
            <div class="cart-drawer-item__details">
              <div class="cart-drawer-item__header-row">
                <a class="cart-drawer-item__title" href="${item.url}">${item.product_title.toUpperCase()}</a>
                <button type="button" class="cart-drawer-item__remove" data-key="${item.key}" aria-label="${t.remove}">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              ${variantTitle}
              <p class="cart-drawer-item__price">${priceFormatted}</p>
              <div class="cart-drawer-item__qty-row">
                <div class="cart-drawer-item__qty-picker">
                  <button type="button" class="cart-drawer-item__qty-btn cart-drawer-item__qty-dec" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                  <input type="number" class="cart-drawer-item__qty-input" data-key="${item.key}" value="${item.quantity}" min="0" aria-label="${t.quantity}">
                  <button type="button" class="cart-drawer-item__qty-btn cart-drawer-item__qty-inc" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                </div>
              </div>
            </div>
          </article>
        `;
      }).join('');

      var totalFormatted = formatMoney(cart.total_price);

      var freeShippingHtml = '';
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cart.currency || 'MXN';
      var country = (window.Shopify && window.Shopify.country) || 'MX';

      var settingsEl = document.getElementById('free-shipping-settings');
      var freeShippingConfig = {
        enabled: true,
        threshold: 1500,
        textProgress: 'Te faltan [amount] para ENVÍO GRATIS',
        textSuccess: '🎉 ¡Felicidades! Tienes ENVÍO GRATIS'
      };

      if (settingsEl) {
        try {
          var parsed = JSON.parse(settingsEl.textContent);
          if (parsed) {
            if (typeof parsed.enabled !== 'undefined') freeShippingConfig.enabled = parsed.enabled;
            if (parsed.threshold) freeShippingConfig.threshold = Number(parsed.threshold);
            if (parsed.textProgress) freeShippingConfig.textProgress = parsed.textProgress;
            if (parsed.textSuccess) freeShippingConfig.textSuccess = parsed.textSuccess;
          }
        } catch (e) {}
      }

      if (freeShippingConfig.enabled && (currency === 'MXN' || country === 'MX')) {
        var threshold = freeShippingConfig.threshold || 1500;
        if (threshold < 10000) {
          threshold = threshold * 100;
        }
        var remaining = threshold - cart.total_price;
        var pct = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));

        var msg = '';
        if (remaining > 0) {
          var template = freeShippingConfig.textProgress || 'Te faltan [amount] para ENVÍO GRATIS';
          var amountHtml = `<strong>${formatMoney(remaining)}</strong>`;
          if (template.indexOf('[amount]') !== -1) {
            msg = template.replace('[amount]', amountHtml);
          } else {
            msg = template + ' ' + amountHtml;
          }
        } else {
          msg = freeShippingConfig.textSuccess || '🎉 ¡Felicidades! Tienes ENVÍO GRATIS';
        }

        var completedClass = remaining <= 0 ? ' is-completed' : '';

        freeShippingHtml = `
          <div class="cart-drawer__shipping-bar-wrap">
            <p class="cart-drawer__shipping-bar-text">${msg}</p>
            <div class="cart-drawer__shipping-bar">
              <div class="cart-drawer__shipping-bar-fill${completedClass}" style="width: ${pct}%;"></div>
            </div>
          </div>
        `;
      }
var completeLookHtml = `
  <div class="cart-drawer__look" id="cart-drawer-look">
    <p class="cart-drawer__look-title">${t.complete_look}</p>
    <div class="cart-drawer__look-products" id="cart-drawer-look-products"></div>
  </div>
`;
var cartProductIds = cart.items.map(function(item) {
  return item.product_id;
});
var recommendationRequests = cart.items.map(function(item) {
  return fetch('/recommendations/products.json?product_id=' + item.product_id + '&limit=10&intent=complementary')
    .then(function(response) {
      return response.json();
    });
});

Promise.all(recommendationRequests)
  .then(function(results) {
    var data = results.find(function(result) {
      return result.products && result.products.length > 0;
    }) || { products: [] };

  var container = document.getElementById('cart-drawer-look-products');
  if (!container || !data.products) return;

  container.innerHTML = data.products
  .filter(function(product) {
    return cartProductIds.indexOf(product.id) === -1;
  })
  .slice(0, 4)
  .map(function(product) {
var image = product.featured_image || '';
    var price = product.variants && product.variants.length
      ? formatMoney(product.variants[0].price)
      : '';
var hasOneVariant = product.variants && product.variants.length === 1;
var variantId = hasOneVariant ? product.variants[0].id : null;

return `
  <div class="cart-drawer__look-product">
    <a href="/products/${product.handle}" class="cart-drawer__look-product-link">
      ${image ? `<img src="${image}" alt="${product.title}">` : ''}
      <span class="cart-drawer__look-product-title">${product.title}</span>
      <span class="cart-drawer__look-product-price">${price}</span>
    </a>
    ${hasOneVariant
      ? `<button type="button" class="cart-drawer__look-add" data-variant-id="${variantId}">${t.add}</button>`
      : `<a href="/products/${product.handle}" class="cart-drawer__look-options">${t.add}</a>`
    }
  </div>
`;
  
  }).join('');
})
  .catch(function(error) {
    console.error('Error cargando Completa tu Look:', error);
  });
      this.bodyContainer.innerHTML = `
        <div class="cart-drawer__items">
          ${itemsHtml}
        </div>
      ${completeLookHtml}  
        <footer class="cart-drawer__footer">
          ${freeShippingHtml}
          <div class="cart-drawer__subtotal-row">
            <span>${t.subtotal}</span>
            <span class="cart-drawer__subtotal-price">${totalFormatted}</span>
          </div>
          <p class="cart-drawer__note">${t.taxes_shipping}</p>
          <div class="cart-drawer__actions">
            <a href="/checkout" class="cart-drawer__btn cart-drawer__btn--checkout">${t.checkout}</a>
            <a href="${window.Shopify?.routes?.root || '/'}cart" class="cart-drawer__btn cart-drawer__btn--view-cart">${t.view_cart}</a>
          </div>
        </footer>
      `;
    }
  };
  document.addEventListener('click', function(event) {
  var button = event.target.closest('.cart-drawer__look-add');
  if (!button) return;

  event.preventDefault();

  var variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  button.disabled = true;
  var originalText = button.textContent;
  button.textContent = 'AGREGANDO...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: Number(variantId),
      quantity: 1
    })
  })
  .then(function(response) {
    if (!response.ok) throw new Error('No se pudo agregar el producto');
    return response.json();
  })
  .then(function() {
    return CartDrawer.refresh();
  })
  .catch(function(error) {
    console.error('Error agregando producto:', error);
    button.disabled = false;
    button.textContent = originalText;
  });
});

  window.CartDrawer = CartDrawer;

  document.addEventListener('DOMContentLoaded', function () {
    CartDrawer.init();
  });
})();
